import React from 'react';
import { ImportLegacyResultsData } from './useAdminLegacyResults';
import { Dialog, FormGrid } from '../../toolympus/components/primitives';
import { ArrowLeft } from '@mui/icons-material';
import { Button, TableContainer, TableHead, Select, MenuItem, TableBody, Table, TableRow, TableCell, Typography } from '@mui/material';
import { FormControl, FormControlsForFields } from '../../toolympus/components/schemed';
import { FieldType } from '../../toolympus/hooks/useSchema';

interface Props {
  data: ImportLegacyResultsData;
}

export const LegacyResultsImportDialog = (props: Props) => {
  const { data } = props;

  if(!data.item) {
    return null;
  }

  return (
    <Dialog
      dialogTitle="Import results"
      noFullscreen
      submitOnModEnter
      maxWidth="lg"
      fullWidth
      actions={<>
        {data.stage !== "stage1" &&
          <Button size="small" startIcon={<ArrowLeft />} onClick={() => data.restart()}>
            back
          </Button>}
        {data.stage === "stage1" &&
          <Button size="small" color="primary" onClick={() => data.process1()}>
            process
          </Button>}
        {data.stage === "stage2" &&
          <Button size="small" color="primary" disabled={data.item.fieldsMapping.filter(f => !!f).length < 3} onClick={() => data.process2()}>
            process further
          </Button>}
        {data.stage === "stage3" &&
          <Button size="small" variant="contained" color="primary" disabled={!data.canFinish} onClick={() => data.save()}>
            import
          </Button>}
      </>}
      {...data.dialog}>

        {!!data.item &&
          <>
            {data.stage === "stage1" &&
              <FormGrid noMargin columns="1fr">
                <FormControlsForFields
                  data={data.item}
                  onChange={(o,c) => data.update(c)}
                  schema={{ textIn: { type: FieldType.textlong, label: "Paste from Excel"}}}
                  fields={[
                    ["textIn"],
                  ]}
                  />
              </FormGrid>}

            {data.stage === "stage2" &&
              <TableContainer>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {data.item.fieldsMapping.map((f, index) => (
                        <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                          <Select
                            value={f || ""}
                            onChange={e => data.update({ fieldsMapping: data.item?.fieldsMapping?.map((x,idx) => idx === index ? e.target.value : x)})}
                            >
                              <MenuItem value={""}>-</MenuItem>
                            {data.fieldsOptions.map(fo => (
                              <MenuItem key={fo?.field} value={fo?.field}>
                                {fo?.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.item.records.map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <TableCell key={cellIndex}>{cell}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            }

            {data.stage === "stage3" &&
              <TableContainer>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {data.stage3FieldsOptions.map((f, index) => (
                        <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                          <Typography variant="caption">{f.label}</Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.item.recordsPreprocessed.map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {data.stage3FieldsOptions.map(f => (
                          <TableCell key={f.field} width={f.field === data.uniFinalField ? 400 : undefined}>
                            {f.field === data.uniFinalField
                              ? (
                                <FormControl
                                  field={f.field}
                                  schema={f as any}
                                  onChange={(o,c) => data.updateRowUniversity(rowIndex, c[f.field])}
                                  row={row}
                                  extraProps={{ label: " ", autoComplete: true }}
                                  error={!row[f.field]}
                                  />
                              )
                              : row[f.field]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            }
          </>}
    </Dialog>
  );
}
